import React from "react";
import {useHistory} from "react-router";

import {OSMGenericNearbyOffersMap} from "../../maps/components/generic_nearby_offers/open_street_maps/OSMGenericNearbyOffers";
import {Country} from "../../region/types/Country";
import {ViewType} from "../../view_type/ViewType";
import {createOfferLink} from "../helpers/create_offer_link";
import {transformRelatedOfferIntoMapOffer} from "../helpers/transform_related_offer_into_map_offer";
import {IRelatedOfferList} from "../list/types/IOfferListResponse";

const offerPinSmall = require("../../maps/images/pins/offer_pin_small.svg");
const disabledOfferPin = require("../../maps/images/pins/disabled_offer_pin.svg");

interface IProps {
    viewType: ViewType;
    originCoordinates: [number, number];
    originCountry: Country;
    offers: IRelatedOfferList[];
}

const getMarkerIcon = () => offerPinSmall;

const findOffer = (offers: IRelatedOfferList[], offerId: number): IRelatedOfferList | undefined => offers.find((offer) => offer.id === offerId);

const getOfferLink = (offers: IRelatedOfferList[], offerId: number): string | undefined => {
    const offer = findOffer(offers, offerId);

    if (offer) {
        return createOfferLink(offer);
    }
};

const NearbyOffersMapC: React.FC<IProps> = (props) => {
    const history = useHistory();
    const offersData = props.offers.map(transformRelatedOfferIntoMapOffer);

    const handleOfferClick = (offerId: number) => {
        const offerLink = getOfferLink(props.offers, offerId);

        if (offerLink) {
            history.push(offerLink);
        }
    };

    return (
        <>
            <OSMGenericNearbyOffersMap
                viewType={props.viewType}
                originalMarkerCoordinates={props.originCoordinates}
                originalMarkerCountry={props.originCountry}
                offers={offersData}
                getMarkerIcon={getMarkerIcon}
                originalMarkerIcon={disabledOfferPin}
                onDesktopInfoWindowOpen={handleOfferClick}
                onMobileInfoWindowClick={handleOfferClick}
            />
        </>
    );
};

export const NearbyOffersMap = React.memo(NearbyOffersMapC);
